/**
 * ONUNode - Custom React Flow node for ONU (Optical Network Unit - end customer)
 */
import React from 'react';
import { Handle, Position, NodeProps } from '@xyflow/react';
import './FiberTopologyNodes.css';

export interface ONUNodeData {
  label: string;
  totalLoss: number;
  cableId?: number;
  fiberNumber?: number;
  poleId?: number;
  onuId?: number;
  fiberColor?: string;
  status?: string;
}

const FIBER_COLOR_MAP: Record<string, string> = {
  'blue': 'Modrá',
  'orange': 'Oranžová',
  'green': 'Zelená',
  'brown': 'Hnedá',
  'gray': 'Sivá',
  'white': 'Biela',
  'red': 'Červená',
  'black': 'Čierna',
  'yellow': 'Žltá',
  'violet': 'Fialová',
  'pink': 'Ružová',
  'turquoise': 'Tyrkysová',
};

const STATUS_ICON_MAP: Record<string, string> = {
  'pending': '⏳',
  'active': '✅',
  'inactive': '⏸️',
  'offline': '❌',
};

export const ONUNode: React.FC<NodeProps> = ({ data: nodeData, selected }) => {
  const data = nodeData as unknown as ONUNodeData;
  const isLossOk = data.totalLoss <= 28; // GPON standard max loss
  const lossStatus = isLossOk ? 'ok' : 'error';

  return (
    <div className={`fiber-node onu-node ${selected ? 'selected' : ''} loss-${lossStatus}`}>
      <div className="node-header">
        <span className="node-icon">📡</span>
        <span className="node-title">ONU</span>
        {data.status && (
          <span style={{ marginLeft: '4px', fontSize: '14px' }}>
            {STATUS_ICON_MAP[data.status] || ''}
          </span>
        )}
      </div>
      <div className="node-body">
        <div className="node-field">
          <span className="field-label">Zákazník:</span>
          <span className="field-value">{data.label}</span>
        </div>
        {data.fiberColor && (
          <div className="node-field">
            <span className="field-label">Farba vlákna:</span>
            <span className="field-value" style={{
              padding: '2px 6px',
              backgroundColor: '#f3f4f6',
              borderRadius: '4px',
              fontSize: '11px',
              fontWeight: 600
            }}>
              {FIBER_COLOR_MAP[data.fiberColor] || data.fiberColor}
            </span>
          </div>
        )}
        {data.cableId && (
          <div className="node-field">
            <span className="field-label">Kábel:</span>
            <span className="field-value">#{data.cableId}</span>
          </div>
        )}
        {data.fiberNumber && (
          <div className="node-field">
            <span className="field-label">Vlákno:</span>
            <span className="field-value">#{data.fiberNumber}</span>
          </div>
        )}
        <div className={`node-field loss-field loss-${lossStatus}`}>
          <span className="field-label">Celkový útlm:</span>
          <span className="field-value">
            {isLossOk ? '✓' : '⚠️'} {(data.totalLoss || 0).toFixed(2)} dB
          </span>
        </div>
        {!isLossOk && (
          <div className="node-warning">
            Exceeds 28 dB limit!
          </div>
        )}
      </div>
      <Handle
        type="target"
        position={Position.Left}
        id="input"
        className="fiber-handle target-handle"
      />
    </div>
  );
};

